module.exports = __webpack_public_path__ + "img/azerbaijan.008a1cab.png";